var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprovalNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "334.33 643.94 30 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M359.01,644.79c-.81-.84-1.95-1.35-3.2-1.35h-12.96c-1.23,0-2.36.51-3.17,1.35-.84.81-1.35,1.95-1.35,3.17v12.96c0,1.26.51,2.36,1.35,3.2.81.81,1.95,1.32,3.17,1.32h12.96c1.26,0,2.39-.51,3.2-1.32.81-.84,1.32-1.95,1.32-3.2v-12.96c0-1.23-.51-2.36-1.32-3.17ZM356.88,650.95l-9.47,8.64c-.23.18-.5.27-.76.27-.31,0-.61-.13-.82-.37l-4.12-4.81c-.37-.48-.32-1.16.12-1.55.5-.39,1.19-.33,1.58.11l3.38,3.92,8.57-7.82c.18-.19.45-.3.74-.3h0c.3,0,.6.12.82.34.2.2.31.47.31.76,0,.3-.12.6-.34.82Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovalNav);
export default __webpack_public_path__ + "static/media/approval-nav.01a701d93815e936a3251ff2ad8a36a7.svg";
export { ForwardRef as ReactComponent };